export default __webpack_public_path__ + "static/media/hammadDogar.5e8a8406.jpeg";